import { createSelector } from '@reduxjs/toolkit';

const selectTrimming = state => state.trimming;

export const selectSendingNewTrim = createSelector(
  selectTrimming,
  trimming => trimming.sendingNewTrim
);

export const selectTrimRanges = createSelector(
  selectTrimming,
  trimming => trimming.trim_ranges
);
